import { useCallback, useSyncExternalStore } from "react";
import { getThemeController } from "./theme";
import type { ResolvedTheme } from "./theme";
import type { ThemePreference } from "./color";

const SERVER_THEME: ResolvedTheme = {
    preference: "system",
    theme: "dark",
};

export interface ThemePreferenceState extends ResolvedTheme {
    readonly setPreference: (preference: ThemePreference) => void;
}

export function useThemePreference(): ThemePreferenceState {
    const controller = getThemeController();

    const snapshot = useSyncExternalStore(
        controller.subscribe,
        controller.getSnapshot,
        () => SERVER_THEME,
    );

    const setPreference = useCallback(
        (preference: ThemePreference) => {
            controller.setPreference(preference);
        },
        [controller],
    );

    return {
        ...snapshot,
        setPreference,
    };
}
